import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ZfIcon, ZfTextButton } from '@zafire/react';
import { useGetCRMCHDirectLODLink } from 'hooks/queries/privateBanking';
import { openInSameTab } from 'utils/browserUtils';

type Props = {
  brUuid: string | undefined;
};

export const OpenDocumentsInCrmButton = ({ brUuid }: Props) => {
  const { t } = useTranslation();
  const { data: crmchLink } = useGetCRMCHDirectLODLink(brUuid);

  const crmchLinkValue = crmchLink?.value;
  const handleClick = useCallback(() => {
    if (crmchLinkValue) {
      openInSameTab(crmchLinkValue);
    }
  }, [crmchLinkValue]);

  return (
    <ZfTextButton size="medium" hierarchy="tertiary" onClick={handleClick}>
      <ZfIcon slot="trailing" name="open_in_new" size="medium" />
      {t('pb.overview.open.documents.crm.label')}
    </ZfTextButton>
  );
};
